import React from "react";

const CheckboxEmptyIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 2C15.1 2 16 2.9 16 4V14C16 15.1 15.1 16 14 16H4C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14ZM14 0H4C1.8 0 0 1.8 0 4V14C0 16.2 1.8 18 4 18H14C16.2 18 18 16.2 18 14V4C18 1.8 16.2 0 14 0Z"
                fill="#BDBDBD"
            />
        </svg>
    );
};

export default CheckboxEmptyIcon;
